export default __webpack_public_path__ + "static/banner-image-089a6e44284246ddcb31168864371e84.jpg";